import $ from 'jquery';

let module = {
	init: function () {
		$('.js-info-widget-toggler').on('click', function(e) {
			e.stopPropagation();
			const $widget = $('.js-info-widget');
			const wasShowing = $widget.hasClass('is-showing');

			$widget.toggleClass('is-showing');

			// Scroll to widget when opening it
			// if (!wasShowing && $widget.hasClass('is-showing')) {
			// 	const offset = 100;
			// 	const widgetTop = $widget.offset().top - offset;

			// 	$('html, body').animate({
			// 		scrollTop: widgetTop
			// 	}, 400);
			// }
		});

		// Close when clicking outside
		$(document).on('click', function(e) {
			const $target = $(e.target);
			const $widget = $('.js-info-widget');

			// Check if click is outside both the toggler and the widget
			if (!$target.closest('.js-info-widget-toggler').length &&
				!$target.closest('.js-info-widget').length) {
				$widget.removeClass('is-showing');
			}
		});
	}
}

export { module as InfoWidget }